import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-add",
  "use": "icon-add-usage",
  "viewBox": "0 0 8 9",
  "content": "<symbol viewBox=\"0 0 8 9\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-add\">\r\n<rect x=\"4.79492\" y=\"0.538086\" width=\"7.5957\" height=\"1.76358\" rx=\"0.88179\" transform=\"rotate(90 4.79492 0.538086)\" fill=\"currentColor\" />\r\n<rect x=\"7.71094\" y=\"5.21777\" width=\"7.5957\" height=\"1.76358\" rx=\"0.88179\" transform=\"rotate(-180 7.71094 5.21777)\" fill=\"currentColor\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol